import { Component, Input } from '@angular/core';
import { AppDataService, ConfigService } from 'app/services';

@Component({
    selector: 'partner-appconfig-categories',
    templateUrl: './partner-appconfig-categories.component.html',
    styleUrls: ['./partner-appconfig-categories.component.scss']
})
export class PartnerAppConfigCategoriesComponent {
    @Input()
    public menuPermissionActive!: string;

    constructor(private appData: AppDataService, public configService: ConfigService) { }

}
